import React, { Component } from "react";
import { style } from "typestyle";

interface IJumbotronProps {
  imageUrl?: string | null;
  header?: string | null;
  subheader?: string | null;
}

export default class Jumbotron extends Component<IJumbotronProps> {
  render(): JSX.Element {
    const { imageUrl, header, subheader } = this.props;

    return (
      <div
        className={style({
          backgroundColor: "#212121",
          width: "100%",
          height: "300px",
          display: "flex",
          alignItems: "flex-end",
          justifyContent: "center",
        })}
      >
        <div
          className={style({
            width: "100%",
            maxWidth: "800px",
            height: "100%",
            boxSizing: "content-box",
            padding: "16px",
            display: "flex",
            flexDirection: "row",
            alignItems: "flex-end",
          })}
        >
          {imageUrl && (
            <img
              className={style({
                width: "160px",
                height: "160px",
                borderRadius: "12px",
              })}
              src={imageUrl}
            />
          )}
          <div
            className={style({
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              justifyContent: "flex-end",
              height: "160px",
              padding: "0 24px",
              color: "white",
              fontWeight: "normal",
            })}
          >
            {header && (
              <div
                className={style({
                  fontSize: "40px",
                  lineHeight: "48px",
                  marginBottom: "16px",
                })}
              >
                {header}
              </div>
            )}
            {subheader && (
              <div
                className={style({
                  fontSize: "20px",
                  lineHeight: "32px",
                  marginBottom: "8px",
                })}
              >
                {subheader}
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}
